var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.36523C33.1046 8.36523 34 9.26067 34 10.3652V18.7652L44.4266 11.4667C44.879 11.1499 45.5026 11.26 45.8192 11.7124C45.9368 11.8805 46 12.0807 46 12.2859V36.4446C46 36.9968 45.5522 37.4446 45 37.4446C44.7948 37.4446 44.5946 37.3814 44.4266 37.2638L34 29.9652V38.3652C34 39.4698 33.1046 40.3652 32 40.3652H4C2.89544 40.3652 2 39.4698 2 38.3652V10.3652C2 9.26067 2.89544 8.36523 4 8.36523H32ZM30 12.3652H6V36.3652H30V12.3652ZM14.8 18.0226C14.9521 18.0226 15.1011 18.066 15.2295 18.1476L23.9394 23.6902C24.3122 23.9274 24.422 24.422 24.1848 24.7948C24.122 24.8934 24.0382 24.9772 23.9394 25.0402L15.2295 30.5828C14.8567 30.82 14.3623 30.7102 14.1251 30.3374C14.0434 30.209 14 30.06 14 29.9078V18.8226C14 18.3808 14.3582 18.0226 14.8 18.0226ZM42 18.0479L34 23.6472V25.0832L42 30.6826V18.0479Z",
    fill: "#3940A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.34c7e2d94633b5d79e6289ce85dcb220.svg";
export { ForwardRef as ReactComponent };